if (!customElements.get('smx-footer-menus')) {
  customElements.define('smx-footer-menus', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const mobile = matchMedia('(max-width: 767.98px)');
      const menus = Array.from(this.querySelectorAll('.smx-footer__menu'));
      const sync = () => menus.forEach(menu => { menu.open = !mobile.matches; });
      mobile.addEventListener('change', sync, { signal: this.controller.signal });
      document.addEventListener('shopify:block:select', event => {
        const menu = event.target.closest('.smx-footer__menu');
        if (menu && this.contains(menu)) menu.open = true;
      }, { signal: this.controller.signal });
      sync();
    }
    disconnectedCallback() { this.controller?.abort(); this.controller = null; }
  });
}
